var _path, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 113,
    viewBox: "0 0 163 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.926 63.4687C177.543 100.992 142.532 113 99.1977 113C55.8639 113 0 98.5215 0 63.4687C0 28.4159 35.129 0 78.4628 0C121.797 0 132.421 18.8691 156.926 63.4687Z",
    fill: "#EDF5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7516 23.1223L65.3067 23.1223L45.6608 54.1098L39.691 54.1098L59.7516 23.1223Z",
    fill: "#4F5BD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7676 19.3554L59.7674 23.1305L39.6913 54.1008L39.6913 50.2291L59.7676 19.3554Z",
    fill: "#4F5BD5",
    fillOpacity: 0.65
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7712 19.3541H65.3068V23.1265H59.7712V19.3541Z",
    fill: "#4F5BD5",
    fillOpacity: 0.65
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.0794,
    cy: 28.4886,
    rx: 5.1014,
    ry: 5.65853,
    fill: "#4F5BD5",
    fillOpacity: 0.65
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.816,
    cy: 28.489,
    rx: 5.1014,
    ry: 5.65853,
    fill: "#4F5BD5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.6165,
    cy: 45.762,
    rx: 5.1014,
    ry: 5.65853,
    fill: "#4F5BD5",
    fillOpacity: 0.65
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.3534,
    cy: 45.7624,
    rx: 5.1014,
    ry: 5.65853,
    fill: "#4F5BD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.437 29.3411L123.019 28.0505V49.5927L119.437 51.7766V29.3411Z",
    fill: "#F55F33",
    fillOpacity: 0.65
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8755 23.7797L119.438 29.2396V51.7745L86.8755 44.9078V23.7797Z",
    fill: "#F55F33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5659 22.7875L123.019 28.0489L119.438 29.3395L86.8755 23.7802L90.5659 22.7875Z",
    fill: "#F55F33",
    fillOpacity: 0.65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2918_4686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.094 42.1929C102.474 42.1929 101.924 42.0979 101.444 41.9079C100.974 41.7179 100.569 41.4579 100.229 41.1279C99.8995 40.7979 99.6345 40.4179 99.4345 39.9879C99.2445 39.5479 99.1145 39.0829 99.0445 38.5929H97.8745V37.6479H98.9545C98.9445 37.5679 98.9395 37.4829 98.9395 37.3929C98.9395 37.2929 98.9395 37.2129 98.9395 37.1529C98.9395 37.0729 98.9395 36.9929 98.9395 36.9129C98.9395 36.8229 98.9445 36.7179 98.9545 36.5979H97.8745V35.6679H99.0445C99.1345 35.1179 99.2895 34.6129 99.5095 34.1529C99.7395 33.6829 100.029 33.2829 100.379 32.9529C100.739 32.6129 101.154 32.3529 101.624 32.1729C102.094 31.9829 102.614 31.8879 103.184 31.8879C103.654 31.8879 104.084 31.9479 104.474 32.0679C104.864 32.1779 105.189 32.3229 105.449 32.5029C105.819 32.7529 106.004 33.0229 106.004 33.3129C106.004 33.4729 105.934 33.6629 105.794 33.8829C105.654 34.0929 105.489 34.2829 105.299 34.4529C105.189 34.3429 105.069 34.2329 104.939 34.1229C104.819 34.0129 104.679 33.9129 104.519 33.8229C104.359 33.7329 104.179 33.6629 103.979 33.6129C103.779 33.5529 103.549 33.5229 103.289 33.5229C102.949 33.5229 102.649 33.5779 102.389 33.6879C102.139 33.7879 101.924 33.9329 101.744 34.1229C101.564 34.3129 101.414 34.5429 101.294 34.8129C101.184 35.0729 101.099 35.3579 101.039 35.6679H104.129V36.5979H100.934C100.924 36.6779 100.919 36.7579 100.919 36.8379C100.919 36.9079 100.919 36.9779 100.919 37.0479C100.919 37.1279 100.919 37.2229 100.919 37.3329C100.919 37.4329 100.929 37.5379 100.949 37.6479H104.129V38.5929H101.069C101.179 39.1929 101.409 39.6779 101.759 40.0479C102.109 40.4079 102.609 40.5879 103.259 40.5879C103.539 40.5879 103.784 40.5579 103.994 40.4979C104.204 40.4279 104.389 40.3479 104.549 40.2579C104.709 40.1579 104.844 40.0579 104.954 39.9579C105.064 39.8479 105.154 39.7529 105.224 39.6729C105.274 39.7329 105.339 39.8079 105.419 39.8979C105.499 39.9879 105.574 40.0879 105.644 40.1979C105.724 40.2979 105.789 40.4079 105.839 40.5279C105.889 40.6379 105.914 40.7429 105.914 40.8429C105.914 41.0829 105.769 41.3179 105.479 41.5479C105.219 41.7479 104.899 41.9029 104.519 42.0129C104.139 42.1329 103.664 42.1929 103.094 42.1929Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4802 38.473L90.9998 38.735V40.9672L89.4802 40.657V38.473Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4802 33.9066L90.9998 34.1686V36.4008L89.4802 36.0906V33.9066Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4802 29.3402L90.9998 29.6022V31.8344L89.4802 31.5242V29.3402Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.445 43.0394L115.964 43.3014V45.5336L114.445 45.2234V43.0394Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.445 38.473L115.964 38.735V40.9672L114.445 40.657V38.473Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.445 33.9066L115.964 34.1686V36.4008L114.445 36.0906V33.9066Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2205 65.0795L63.4304 70.1424V100.42L58.2205 95.4262V65.0795Z",
    fill: "#F9BA0F",
    fillOpacity: 0.65
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.962 65.0795L63.4303 70.1423V100.42L101.962 95.1284V65.0795Z",
    fill: "#F9BA0F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M101.854 65.0791L63.4302 70.142L58.2203 65.0791L95.6667 60.7111L101.854 65.0791Z",
    fill: "#F9BA0F",
    fillOpacity: 0.65
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1759 78.4807L77.2151 77.9844L71.6795 89.1029L68.6404 89.5L74.1759 78.4807Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9445 77.4885L86.9836 76.9922L81.4481 88.1107L78.4089 88.5078L83.9445 77.4885Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7133 76.495L96.7524 75.9987L91.2169 87.1172L88.1777 87.5143L93.7133 76.495Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2918_4686",
    x: 93.8745,
    y: 31.8878,
    width: 16.1299,
    height: 18.3051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2918_4686"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2918_4686",
    result: "effect2_dropShadow_2918_4686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2918_4686",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigRewards);
export default __webpack_public_path__ + "static/media/config-rewards.839e998f04aa1267f0c7f0e7de6d6e93.svg";
export { ForwardRef as ReactComponent };